export default __webpack_public_path__ + "static/media/vti-solution.061a3aed.svg";